
//import List from '@mui/material/List'
//import ListItemText from '@mui/material/ListItemText'
import CustomTable from './customTable';
import React, { forwardRef } from "react";


const DisplayHistory = ({messages, clearMessages}) => {

    console.log("Display History")
    console.log(messages.slice(0,2))

    const clear_table = () => {
        if (! window.confirm('Log entries verwijderen?')) {
            console.log("Not removed")
            return 
          }
          clearMessages(0)
    }

    return (
        <div>
        <CustomTable
        title="Log History"
        columns={[
          {
            headerName: "tijd",
            field: "time",
            width: "10%" 
          },
          {
            headerName: "bericht",
            field: "message"
          }
        ]}
        data={messages}
        // actions={[
        //     {
        //       icon: () => <Delete />,
        //       tooltip: 'Clear Logs',
        //       isFreeAction: true,
        //       onClick: (event) => clear_table()
        //     }
        //   ]}
      />    
    </div>
    )

};


export default DisplayHistory;